import { render, staticRenderFns } from "./ProductionBarChartCard.vue?vue&type=template&id=61ad2114"
import script from "./ProductionBarChartCard.vue?vue&type=script&lang=js"
export * from "./ProductionBarChartCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports